import { ordersHistoryStore } from './ordersHistoryStore/ordersHistoryStore';
import { liveOrdersStore } from './ordersStore/liveOrdersStore';
import { IUser } from '~/types/user';
import client from '~/services/client';

const afterUserHydration = async (user: IUser) => {
  client.headers = {
    Authorization: `Bearer ${user.auth_token}`,
  };

  if (user.id) {
    await liveOrdersStore.hydrate(String(user.id));
    await ordersHistoryStore.hydrate(String(user.id));
  }
};

export default afterUserHydration;
